import { useState, MouseEventHandler, ElementType } from 'react';
import MenuItem from './MenuItem';
import { cn } from '../../../utils';
import { navigateToUrl } from 'single-spa';
import { Prettify } from '@types';

type SecondarySideNavProps = {
    menu?: SideNavMenu[];
    menuActiveItems?: string[];
    bottomMenu?: SideNavMenu[];
    currentClient?: string;
    LinkAs?: ElementType;
    openMenus?: string[];
    onAccordionTriggerClicked?: (id: string) => void;
};

type SideNavMenuItem = {
    id: string;
    name: string;
    url: string;
    href?: string;
    isSpa?: boolean;
    selected?: boolean;
    links?: SideNavMenuItem[];
};

type SideNavMenuLinks = {
    links?: SideNavMenuItem[];
};

export type SideNavMenu = Prettify<SideNavMenuItem & SideNavMenuLinks>;

export default function SecondarySideNav({
    // currentClient,
    menu,
    menuActiveItems = [],
    bottomMenu,
    LinkAs,
    openMenus,
    onAccordionTriggerClicked,
    ...rest
}: SecondarySideNavProps) {
    const [isSecondaryBarOpen, setSecondaryBarOpen] = useState(true);
    return (
        <div
            {...rest}
            onClick={() => {
                if (!isSecondaryBarOpen)
                    setSecondaryBarOpen(!isSecondaryBarOpen);
            }}
            className={cn(
                'alli-z-20 alli-flex alli-transform alli-flex-col alli-space-y-2 alli-border-r alli-border-gray-400 alli-bg-white alli-py-2 alli-duration-150',
                {
                    'alli-min-w-[16.938rem] alli-max-w-[16.938rem] alli-px-2':
                        isSecondaryBarOpen,
                    'alli-w-[1.125rem] alli-cursor-pointer':
                        !isSecondaryBarOpen,
                },
            )}>
            <CollapseButton
                isSecondaryBarOpen={isSecondaryBarOpen}
                onClick={() => {
                    setSecondaryBarOpen(!isSecondaryBarOpen);
                }}
            />

            <div
                className={cn(
                    'alli-h-full alli-flex-col alli-justify-between alli-overflow-y-scroll alli-pb-3 alli-pt-2',
                    {
                        'alli-flex': isSecondaryBarOpen,
                        'alli-hidden': !isSecondaryBarOpen,
                    },
                )}>
                <div>
                    {menu?.map((item, index) => {
                        return (
                            <MenuItem
                                activeMenuItems={menuActiveItems}
                                LinkAs={LinkAs}
                                navigateToUrl={navigateToUrl}
                                key={`sidemenu-${index}`}
                                item={{
                                    ...item,
                                    href: item.url,
                                }}
                                open={openMenus?.includes(item.id)}
                                isSecondaryBarOpen={isSecondaryBarOpen}
                                onAccordionTriggerClicked={
                                    onAccordionTriggerClicked
                                }
                            />
                        );
                    })}
                </div>
                {bottomMenu && bottomMenu?.length > 0 && (
                    <div className="alli-border-t alli-border-gray-400 alli-pt-2">
                        {bottomMenu?.map((item, index) => (
                            <MenuItem
                                activeMenuItems={menuActiveItems}
                                LinkAs={LinkAs}
                                navigateToUrl={navigateToUrl}
                                key={`sidemenu-${index}`}
                                item={{
                                    ...item,
                                    href: item.url,
                                }}
                                open={openMenus?.includes(item.id)}
                                isSecondaryBarOpen={isSecondaryBarOpen}
                                onAccordionTriggerClicked={
                                    onAccordionTriggerClicked
                                }
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

type CollapseButtonProps = {
    isSecondaryBarOpen: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
};

function CollapseButton({ isSecondaryBarOpen, onClick }: CollapseButtonProps) {
    return (
        <button
            data-testid="CollapseButton"
            className={cn(
                'alli-absolute alli-top-1/2 alli-z-50 alli-flex alli-h-6 alli-w-6 -alli-translate-y-1/2 alli-transform alli-cursor-pointer alli-items-center alli-justify-center alli-rounded-full alli-border alli-border-gray-300 alli-bg-white alli-text-blue-gray-900 alli-shadow alli-duration-100',
                {
                    'alli-left-[16.2rem]': isSecondaryBarOpen,
                    '-alli-left-1': !isSecondaryBarOpen,
                },
            )}
            onClick={onClick}
            aria-hidden="true">
            <ChevronRight
                className={cn(
                    'alli-h-4 alli-w-4 alli-transform alli-duration-150',
                    {
                        'alli-rotate-180': isSecondaryBarOpen,
                        'alli-rotate-0': !isSecondaryBarOpen,
                    },
                )}
            />
        </button>
    );
}

type ClassNameProps = {
    className?: string | object;
};

export function ChevronRight({ className }: ClassNameProps) {
    return (
        <svg
            viewBox="0 0 18 18"
            fill="none"
            className={cn(className)}
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.75 3.75L12 9L6.75 14.25"
                className="alli-stroke-current"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
